import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-five',
  templateUrl: './service-five.component.html',
  styleUrls: ['./service-five.component.css']
})
export class ServiceFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
